import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/hooks/use-toast';
import { useOrganization } from '@/hooks/useOrganization';
import {
  getConfiguracoes,
  atualizarConfiguracoes,
  type Configuracoes,
  type ConfiguracoesUpdate,
} from '@/services/configuracoes.service';

export type { Configuracoes, ConfiguracoesUpdate };

export function useConfiguracoes() {
  const { organizationId } = useOrganization();

  return useQuery({
    queryKey: ['configuracoes', organizationId],
    queryFn: () => getConfiguracoes(),
  });
}

export function useAtualizarConfiguracoes() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dados: ConfiguracoesUpdate) => atualizarConfiguracoes(dados),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['configuracoes'] });
      toast({
        title: 'Configurações salvas',
        description: 'As alterações foram aplicadas com sucesso.',
      });
    },
    onError: (error) => {
      toast({
        title: 'Erro ao salvar',
        description: error.message,
        variant: 'destructive',
      });
    },
  });
}
